module.exports = __webpack_public_path__ + "img/heart.35d3b1bc.png";